import { get } from "lodash";
import { deepCopy } from "../../../../utils/deepCopy";

export const fetchTrendHeatmapTableStarted = (state, payload) => {
    return {
        ...state,
        trendHeatmapTableApi: {
            isProcessing: true,
            error: false
        },
        trendComparisonSelectedValue:payload.trendComparisonSelectedValue?payload.trendComparisonSelectedValue:state.trendComparisonSelectedValue,
        trendSelectedHeaders: payload.data || [],
        trendFilters: payload.filters,
        trendByScore: payload.byScore,
        trendMultipleSelect: payload.multipleSelect,
        trendSelectedUserData: payload.selectedUserData,
        trendComparisonSurveys: payload.setupData ? setSurveyComparisonDropDown(payload.setupData, payload.projectId) : state.trendComparisonSurveys
    }
}

export const fetchTrendHeatmapTableSuccess = (state, payload) => {
    let heatmapColumns = [];
    let heatmapData = [];
    let heatmapColumnList = []
    let initialLoad = payload.request.initialLoad
    if (payload.data && payload.data.data) {
        heatmapColumns = payload.data.data.columnData;
        heatmapColumnList = payload.data.data.columnList
        heatmapData = payload.data.data.dataMap
        if (payload.request.projectType && payload.request.projectType === "Very_Simple_Survey") {
        } else {
            heatmapData.forEach((item) => {
                if (item.name !== "Responses") {
                    item.children = [];
                    item.key = item.name
                }
            })
        }

    }
    return {
        ...state,
        trendHeatmapTableApi: {
            isProcessing: false,
            error: false
        },
        trendHeatmapColumns: deepCopy(heatmapColumns),
        trendHeatmapData: deepCopy(heatmapData),
        trendHeatmapChildrenList: deepCopy(heatmapColumns),
        trendHeatmapColumnList: deepCopy(heatmapColumnList),
        isDataFetchedTrend: initialLoad ? true : state.isDataFetchedTrend
    }

}

export const fetchTrendHeatmapTableFailed = (state, payload) => {
    return {
        ...state,
        trendHeatmapTableApi: {
            isProcessing: false,
            error: true
        },
        trendHeatmapColumns: [],
        trendHeatmapData: [],
        trendHeatmapChildrenList: [],
        trendHeatmapColumnList: [],
        isDataFetchedTrend: false
    }

}

export const trendUpdateScoreLevel = (state, payload) => {
    return { ...state, trendSelectedScoreLevel: payload.data };
};

export const trendUpdateComparisonLevel = (state, payload) => {
    return { ...state, trendComparisonSelectedValue: payload.data };
};

const setSurveyComparisonDropDown = (data, currentProjectId) => {
    let generatedList = []
    if (data && data.data) {
        let dataListCopy = deepCopy(data.data)
        dataListCopy.map((item) => {
            if (item.isQuestionMapped && item.isTopicMapped) {
                generatedList.push(
                    {
                        label: item.projectName,
                        value: item.projectId
                    })
            }
        })
    }
    return generatedList
}